const ACTION_SIMULATION_ETAT = 'simulation';

export default ACTION_SIMULATION_ETAT;
